/** @format */

import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { TranslationProvider } from '@context/translation-context';
import Loader from '@components/loader';
const CourseListing = lazy(
  () => import(/* webpackChunkName: "course_listing" */ './course-listing')
);

/**
 * Build Image Gallery.
 */
export const courseListing = () => {
  const courseListing = document.getElementById('courses-training');
  if (courseListing) {
    const root = createRoot(courseListing);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <CourseListing />
        </TranslationProvider>
      </Suspense>
    );
  }
};
